import React, { useState, useEffect } from 'react';
import { apiFetch } from '../../utils/api';
import './Feedback.css'; // Assuming you create this CSS file based on the provided CSS

const Feedback = () => {
  const [userData, setUserData] = useState({ userId: '', username: '' });
  const [feedback, setFeedback] = useState('');
  const [category, setCategory] = useState('');
  const [message, setMessage] = useState('');
  const [messageColor, setMessageColor] = useState('#d32f2f');
  const [submitting, setSubmitting] = useState(false);
  const userEmail = localStorage.getItem('userEmail'); // Replace with dynamic user email from localStorage

  // Fetch user info on component mount
  useEffect(() => {
    const userEmail = localStorage.getItem('userEmail');
    const fetchUserInfo = async () => {
      try {
        const data = await apiFetch(`${window._env_.API_BASE_URL}/users/info?email=${userEmail}`);
        if (data) {
          setUserData({
            userId: data.user_id,
            username: data.username,
          });
        }
      } catch (error) {
        console.error('Error fetching user info:', error);
        setMessage('Failed to load user information.');
      }
    };

    fetchUserInfo();
  }, [userEmail]);

  // Helper: Check if string contains at least one alphanumeric character
  const hasAlphanumeric = (str) => /[a-zA-Z0-9]/.test(str);

  // Helper: Count words (words are separated by whitespace)
  const wordCount = (str) => (str.trim().split(/\s+/).filter(Boolean).length);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage('');

    // Validation: not only spaces/special chars, min 10 words
    if (!feedback.trim() || !hasAlphanumeric(feedback)) {
      setMessage('Feedback cannot be empty, only spaces, or only special characters or only combination of both.');
      setMessageColor('#d32f2f');
      return;
    }
    if (wordCount(feedback) < 10) {
      setMessage('Feedback must be at least 10 words.');
      setMessageColor('#d32f2f');
      return;
    }
    // Validation: category must be selected
    if (!category) {
      setMessage('Please select a category.');
      setMessageColor('#d32f2f');
      return;
    }

    setSubmitting(true);
    const feedbackData = {
      user_id: userData.userId,
      feedback_text: feedback,
      category: category,
    };

    try {
      const result = await apiFetch(`${window._env_.API_BASE_URL}/feedback/form`, {
        method: 'POST',
        body: JSON.stringify(feedbackData),
      });
      setMessage(result.message || 'Feedback submitted successfully!');
      setMessageColor('#2e7d32');
      setFeedback('');
      setCategory('');
    } catch (error) {
      console.error('Error submitting feedback:', error);
      setMessage('Failed to submit feedback. Please try again.');
      setMessageColor('#d32f2f');
    }
    setSubmitting(false);
    setTimeout(() => {
      setMessage('');
    }, 3000);
  };

  return (
    <div className="feedback-container">
      <h2>Submit Your Feedback</h2>
      <form id="feedbackForm" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="username">Username:</label>
          <input type="text" id="username" name="username" value={userData.username} readOnly required />
        </div>
        <div className="form-group">
          <label htmlFor="feedback">Feedback:</label>
          <textarea
            id="feedback"
            name="feedback"
            rows="5"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            required
          ></textarea>
        </div>
        <div className="form-group">
          <label htmlFor="category">Category:</label>
          <select
            id="category"
            name="category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            required
          >
            <option value="" disabled>Select a category</option>
            <option value="Course">Course</option>
            <option value="Platform">Platform</option>
            <option value="Support">Support</option>
            <option value="Others">Others</option>
          </select>
        </div>
        <button
          type="submit"
          className="submitbutton"
          disabled={submitting}
          style={{ cursor: submitting ? 'not-allowed' : 'pointer' }}
        >
          {submitting ? 'Submitting...' : 'Submit'}
        </button>
      </form>
      <div id="message" className="message" style={{ display: message ? 'block' : 'none', color: messageColor }}>
        {message}
      </div>
    </div>
  );
};

export default Feedback;